<template>
  <div>
    <div class="plan-header">
      <div class="left-title" v-text="$t('bill.title')"></div>
    </div>
    <div class="content-body">
      <div class="top">
        <div class="left-z">
          <div class="status">{{ $t('bill.balance') }}：<span v-text="company_balance"></span></div>
          <div class="status">{{ $t('bill.freeze_money') }}：<span>0.00</span></div>
        </div>
        <div class="btn">
          <!-- <el-button type="primary" size="small">修改密码</el-button> -->
        </div>
      </div>
      <div class="body">
        <div class="condition">
          <div class="form">
            <div class="demo-input-suffix">
              {{ $t('bill.condition1') }}:
              <el-date-picker v-model="form.pay_time" type="daterange" value-format="yyyy-MM-dd" style="width: 250px;" align="right" size="small" range-separator="~" start-placeholder="" end-placeholder=""></el-date-picker>
            </div>
            <div class="demo-input-suffix">
              {{ $t('bill.condition2') }}:
              <el-select v-model="form.type" size="small" style="width: 160px; margin-left: 10px;">
                <el-option :label="$t('bill.condition_label')" value=""></el-option>
                <el-option :label="item.label" :value="item.value" v-for="(item, index) in options" :key="index"></el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="getData" size="small" v-text="$t('bill.search_btn')"></el-button>

            <div style="margin: 20px 0;"></div>
          </div>
          <div class="table">
            <el-table :data="tableData" border style="width: 1250px;" size="small" :empty-text="$t('common.empty_text')" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
              <el-table-column width="160" :label="$t('bill.td1')" align="center">
                <template>
                  {{ user_name }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('bill.td2')" width="200" align="center">
                <template>
                  {{ company_name }}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" :label="$t('bill.td3')" width="160" align="center"></el-table-column>
              <el-table-column :label="$t('bill.td4')" width="160" align="center">
                <template slot-scope="scope">
                  {{ scope.row.type === 'pay' ? $t('bill.type1') : $t('bill.type2') }}
                </template>
              </el-table-column>
              <el-table-column prop="money" :label="$t('bill.td5')" width="120" align="center"></el-table-column>
              <el-table-column prop="order_no" :label="$t('bill.td6')" width="199" align="center"></el-table-column>
              <el-table-column :label="$t('bill.td7')" width="250" align="center">
                <template slot-scope="scope">
                  {{ scope.row.remark !== "0" ? scope.row.remark : '' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="page-c">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 20, 30, 40, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  /* global require */
  name: 'bill',
  data() {
    return {
      form: {
        status: '',
        type: '',
        plan_id: '',
        adv_id: '',
        pay_time: [],
        system: '',
        value: '1'
      },
      page: 1,
      pageSize: 10,
      pageTotal: 1,
      tableData: [],
      options: [{
        value: 'pay',
        label: '账户充值'
      }, {
        value: 'log',
        label: '消费'
      }],
      user_name: '',
      company_name: '',
      company_balance: '0.00'
    };
  },
  mounted() {
    this.$function.hiddenLoading();
    this.setTimeInit();
    this.getData();
  },
  methods: {
    getData() {
      this.form = Object.assign({}, this.form, { page: this.page, pageSize: this.pageSize });
      this.$http.post('/trader/index/getBillLists', this.form).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = res.count;
          this.$function.hiddenLoading();
          this.user_name = sessionStorage.getItem('user_info') ? JSON.parse(sessionStorage.getItem('user_info'))['contact_mail'] : '';
          this.company_balance = sessionStorage.getItem('user_info') ? JSON.parse(sessionStorage.getItem('user_info'))['company_balance'] : '0.00';
          this.company_name = sessionStorage.getItem('user_info') ? JSON.parse(sessionStorage.getItem('user_info'))['company_name'] : '';
        }
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    setTimeInit() {
      const day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000 * 2);
      const preToday = day1.getFullYear() + '-' + ((day1.getMonth() + 1) < 10 ? '0' + (day1.getMonth() + 1) : (day1.getMonth() + 1)) + '-' + (day1.getDate() < 10 ? '0' + day1.getDate() : day1.getDate());
      const day2 = new Date();
      day2.setTime(day2.getTime());
      const today = day2.getFullYear() + '-' + ((day2.getMonth() + 1) < 10 ? '0' + (day2.getMonth() + 1) : (day2.getMonth() + 1)) + '-' + (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate());
      this.form.pay_time = [preToday, today];
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    }
  },
  watch: {

  }
};
</script>

<style lang="less" scoped>
  .plan-header {
    width: calc(100% - 32px);
    padding: 0 16px;
    height: 48px;
    display: flex;
    flex-shrink: 0;
    background: #fff;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 66px;
    left: 0;
    background: #fff;
    z-index: 99;
    .left-title {
      line-height: 48px;
      font-size: 18px;
      font-weight: 500;
      color: #222;
    }
    .right-content {
      color: #666;
      font-size: 14px;
    }
  }
  .content-body {
    margin-top: 48px;
  }
  .top {
    height: 54px;
    background-color: #f9f9f9;
    margin-bottom: 31px;
    font-size: 16px;
    font-weight: 700;
    color: #333;
    padding-left: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-z {
      display: flex;
    }
    .status {
      font-size: 14px;
      color: #999;
      font-weight: 400;
      margin-left: 30px;
      span {
        color: #00C6C6;
      }
    }
    .btn {
      float: right;
      margin-right: 40px;
    }
  }

  .body {
    padding: 0px 44px;
  }

  .condition {
    margin-top: 20px;
    width: 1250px;
    height: 55px;
    .form {
      float: left;
      width: 1250px;
    }
    .other {
      float: right;
      width: 440px;
    }
    .demo-input-suffix {
      display: inline-block;
      font-size: 14px;
      color: #999;
      margin-right: 31px;
    }
  }
  .page-c {
    margin-top: 20px;
    text-align: right;
  }

</style>
